import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ACTION_DISCARD_REASONS } from '../common/endpoints';
import { ActionDiscardReason } from '../model';
import { HttpService } from './http.service';


@Injectable()
export class ActionDiscardReasonService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService
    ) { }

    getAllActionDiscardReasons(): Promise<ActionDiscardReason[]> {
        return firstValueFrom(this.http.get<ActionDiscardReason[]>(ACTION_DISCARD_REASONS));
    }

}